import * as React from 'react'
import { BreadCrumbContext } from '../context/BreadCrumbContext'

const useBreadCrumbContext = () => {
    return React.useContext(BreadCrumbContext)
}

export default useBreadCrumbContext
